/**
 * 2v2 davet bağlantısı: `https://<alan>/?takim=K5UY6N` (İngilizce: `?team=`).
 * Bağlantıyı açan oyuncu giriş yaptıktan sonra doğrudan o lobiye katılır.
 */

/** Sunucunun lobi kodu alfabesi (apps/server/src/team/engine.ts): 0/O ve 1/I yok. */
const CODE_PATTERN = /^[ABCDEFGHJKMNPQRSTUVWXYZ23456789]{6}$/;

export function inviteParam(edition: "tr" | "en"): string {
  return edition === "en" ? "team" : "takim";
}

export function teamInviteUrl(origin: string, code: string, edition: "tr" | "en"): string {
  const url = new URL("/", origin);
  url.searchParams.set(inviteParam(edition), code);
  return url.toString();
}

/** Adres satırındaki davet kodunu okur; biçimi tutmayan değer yok sayılır. */
export function readTeamInviteCode(search: string, edition: "tr" | "en"): string | null {
  const value = new URLSearchParams(search).get(inviteParam(edition))?.trim().toUpperCase();
  return value && CODE_PATTERN.test(value) ? value : null;
}
